import {
  baseScreen,
} from 'hoc';
import React from 'react';
import i18n from 'i18n-js';
import {
  useStores,
} from 'hooks';
import {
  useHistory,
  useParams,
} from 'react-router';
import * as Yup from 'yup';
import GeneralFormFields from 'src/components/GeneralFormView/types';
import GeneralFormView from 'src/components/GeneralFormView';
import {
  FormFieldsBuilder,
} from 'src/components/GeneralFormView/Utils/FormFieldsBuilder';
import {
  LanguagesKey,
} from 'src/translations/types';
import {
  Grade,
} from '../grades/types';

const gradesForm: React.FC = () => {
  const {
    backend: {
      grades,
    },
  } = useStores();
  const history = useHistory();
  const {
    id: gradeId,
  } = useParams() as any;
  return (
    <GeneralFormView<any, Grade>
      title={i18n.t('GRADES')}
      identifier="id"
      defaultLang=""
      otherLanguages={[]}
      formData={new FormFieldsBuilder<Grade>()
        .addField('englishName', {
          type: GeneralFormFields.INPUT_FIELD,
          title: i18n.t('ENGLISH_TITLE'),
          validationSchema: Yup.string().required(i18n.t('REQUIRED_FIELD')),
          fieldOptions: {},
        })
        .addField('arabicName', {
          type: GeneralFormFields.INPUT_FIELD,
          title: i18n.t('ARABIC_TITLE'),
          validationSchema: Yup.string().required(i18n.t('REQUIRED_FIELD')),
          fieldOptions: {},
        })
        .formFields}
      isFetchSuccessful
      update={async (id, data) => {
        try {
          if (gradeId) {
            await grades.updateGrade(gradeId, {
              translations: [
                {
                  languageCode: LanguagesKey.AR,
                  title: data.arabicName,
                }, {
                  languageCode: LanguagesKey.EN,
                  title: data.englishName,
                },
              ],
            });
          }
          history.push('/system-setup/system-setup/grades');
          return Promise.resolve();
        } catch (error) {
          return Promise.reject(error);
        }
      }}
      create={async (data) => {
        try {
          await grades.create({
            translations: [
              {
                languageCode: LanguagesKey.AR,
                title: data.arabicName,
              }, {
                languageCode: LanguagesKey.EN,
                title: data.englishName,
              },
            ],
          });
          history.push('/system-setup/system-setup/grades');
          return Promise.resolve(1);
        } catch (error) {
          return Promise.reject(error);
        }
      }}
      get={async () => {
        let res: any = {};
        if (gradeId) {
          res = await grades.getOne(gradeId);
        }
        return Promise.resolve(new Grade(res));
      }}
    />
  );
};

export const GradesForm = baseScreen(gradesForm, {
  allowedRoles: ['ADMIN', 'NONE'],
});
